import { Modal, Button } from "antd";
import styled from "styled-components";
import { showSuccess, showError } from "infra/helpers/alerta";
import useDeleteClasse from "../../hooks/useDeleteClasse";
import useModal from "../../hooks/useModal";

interface DeleteModalProps {
  refetch: () => void;
}

function DeleteModal({ refetch }: DeleteModalProps) {

  const { mutateAsync, isLoading } = useDeleteClasse();
  const { id, isDeleting, classe, setIsDeleting } = useModal();

  async function handleDelete() {
    const response = await mutateAsync(id!);
    if (response.status === 204) {
      showSuccess("Classe de Operação deletada com sucesso!");
      setIsDeleting(false);
      refetch();
      return;
    }
    const details = (response as any).response.data.Details;
    const error = details[0].Errors[0];
    showError(error);
    setIsDeleting(false);
  }

  return (
    <CustomModal
      title="Excluir Classe"
      visible={isDeleting}
      onCancel={() => setIsDeleting(false)}
      maskClosable={false}
      footer={
        <>
          <Button
            size="large"
            loading={isLoading}
            onClick={() => setIsDeleting(false)}
            style={{ borderRadius: 8 }}
          >Cancelar</Button>
          <Button
            size="large"
            type="primary"
            danger
            loading={isLoading}
            onClick={handleDelete}
            style={{ borderRadius: 8 }}
          >Confirmar</Button>
        </>
      }
    >
      <p>Tem certeza que deseja excluir a classe <b>{classe}</b>?</p>
    </CustomModal>
  );
}

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #ff4d4f;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;

export default DeleteModal;
